import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Details extends React.Component {

  static propTypes = {
    entity_type: PropTypes.string,
    entity_id: PropTypes.number,
    onCancel: PropTypes.func,
    onDone: PropTypes.func
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { entity_type, entity_id, mjson_type, publish } = this.props
    return {
      title: 't(Translate Content)',
      method: 'PATCH',
      action: '/api/admin/mjson/translate',
      saveText: 't(Next)',
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            {
              name: 'entity_type',
              type: 'hidden',
              value: entity_type
            },
            {
              name: 'entity_id',
              type: 'hidden',
              value: entity_id
            },
            { 
              label: 't(Language)', 
              name: 'to_language', 
              type: 'languagefield',
              required: true
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.props.onCancel()
  }

  _handleSuccess() {
    this.props.onDone()
  }

}

export default Details
